import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentStatementContainerModel } from "../../../../../../models";
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Pagination } from '../../shared/pagination.model';
import { PmtStmtLineReportDto } from '../../../data-transfer-objects'
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared/api-visa.model';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class PaymentStatementService extends BaseApiPublicLoginTemplateService<PaymentStatementContainerModel,PaymentStatementContainerModel, PaymentStatementContainerModel> {

  static readonly PMT_STMT_SUB_PATH = 'payment-statements/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementService.PMT_STMT_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
  private endpoint_path_without_ep;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementService.PMT_STMT_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementService.PMT_STMT_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_without_ep = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementService.PMT_STMT_SUB_PATH
    // TODO: Change to respected ep-types once they are complete
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementService.PMT_STMT_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + PaymentStatementService.PMT_STMT_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
  }

  public matchByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl + '/match/' + guid,
      {},
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaForPmtStmtLineReport (
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<PmtStmtLineReportDto>> {
    if (this.endpoint_path_without_ep && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep;
    }
    const UrlByCriteria =
      this.apiUrl + 'pmt-stmt-line-report/' + BaseApiTemplateService.BACKOFFICE_EP + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PmtStmtLineReportDto>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}

